import { APIClient } from "@velzon/utils/axios/api_helper.js";

// Served by the admin API (GET /api/activity/list). Uses the shared admin client so the
// accessToken cookie is sent and an expired token is refreshed like other admin calls.
const AxiosClient = new APIClient()
const activityList = (query) => AxiosClient.get(`/activity/list${query}`)

export {
  activityList
}
